import { createSlice } from '@reduxjs/toolkit'

interface LfcState {
  color: {
    colorUnique: any | null
    color: any | null
    colorPickerVisible: boolean
    alias: Record<PropertyKey, any>
  }
}

const initialState: LfcState = {
  color: {
    colorUnique: null,
    color: null,
    colorPickerVisible: false,
    alias: {},
  },
}

const lfcSlice = createSlice({
  name: 'lfc',
  initialState,
  reducers: {
    setColorUnique(state, action) {
      state.color.colorUnique = action.payload
    },
    setColor(state, action) {
      state.color.color = action.payload
    },
    showColorPicker(state, action) {
      state.color.colorPickerVisible = action.payload
    },
    setAlias(state, action) {
      state.color.alias = action.payload
    },
  },
})

export const { setColorUnique, setColor, showColorPicker, setAlias } = lfcSlice.actions

export default lfcSlice.reducer
